import { useQuery } from '@tanstack/react-query'
import { getApiClient } from '@/lib/api'
import type {
  FunnelOverviewResponse,
  FunnelPolicyEventsResponse,
  FunnelSegmentAxis,
  FunnelSegmentsResponse,
} from '@/lib/api'

/**
 * 営業ファネル dashboard のデータ取得フック（GR-04c-4）。
 * データ源は cb_funnel_snapshots（集計値のみ）。MCP tool（sales_progress /
 * segmented_funnel）と同じ snapshot を読むため、チャットと画面で数字が一致する。
 */
export function useFunnelOverview(months = 6) {
  return useQuery<FunnelOverviewResponse>({
    queryKey: ['funnel', 'overview', months],
    queryFn: () => getApiClient().getFunnelOverview(months),
    staleTime: 5 * 60 * 1000,
  })
}

export function useFunnelSegments(axis: FunnelSegmentAxis, months = 6, enabled = true) {
  return useQuery<FunnelSegmentsResponse>({
    queryKey: ['funnel', 'segments', axis, months],
    queryFn: () => getApiClient().getFunnelSegments(axis, months),
    staleTime: 5 * 60 * 1000,
    enabled,
  })
}

export function useFunnelPolicyEvents(months = 12) {
  return useQuery<FunnelPolicyEventsResponse>({
    queryKey: ['funnel', 'policy-events', months],
    queryFn: () => getApiClient().getFunnelPolicyEvents(months),
    staleTime: 5 * 60 * 1000,
  })
}
